//
// Login:
//

export const index = {
    path   : '/recruit_stages/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/recruit_stages/:recruit_stages_id/',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/recruit_stages/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/recruit_stages/:recruit_stages_id/',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/recruit_stages/:recruit_stages_id/',
  method : 'DELETE',
  version: '/v1'
}
